import {component_tool, utils_tool} from '@/tool';
import React from 'react';
import UpdatePersonnelState from './updatePersonnelState';
import UpdateBenchmarkState from './updateBenchmarkState';
import UpdatePositionAuthState from './updatePositionAuthState';
import LookPositionAuthState from './lookPositionAuthState';
import PositionAuthStateImport from './positionAuthStateImport';
import "./index.less";
import { Alert } from 'antd';

let {WizModal, WizSurveyAudience, WizTypography, WizRow,WizDataTable,WizButton,WizAlert} = component_tool;
let {$$, checkStrLength,Storage} = utils_tool;

//配置项
let componentName = 'requirementPersonnelDetail'
const columns = ({type = null},_this,headList) => {
  let columnsBase = [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "岗位名称",
      name: "positionName",
      dataIndex: "positionName",
      tableItem: {width: 120}
    },
    {
      title: "姓名",
      name: "fullName",
      dataIndex: "fullName",
      tableItem: {width: 100}
    },
    {
      title: "账号",
      name: "userName",
      dataIndex: "userName",
      tableItem: {width: 120}
    }
  ];
  let columns = [
    {
      title: "路径阶段",
      name: "onlineState",
      dataIndex: "onlineState",
      tableItem: {width: 100},
      dict: [
        {code: 0, codeName: "● 合格"},
        {code: 1, codeName: "● 不合格"},
        {code: 3, codeName: "○ "},
        {code: 4, codeName: ""},
      ],
      requirementType:0,
    },
    {
      title: "认证",
      name: "certState",
      dataIndex: "certState",
      tableItem: {width: 100},
      dict: [
        {code: 0, codeName: "● 合格"},
        {code: 1, codeName: "● 不合格"},
        {code: 3, codeName: "○ "},
        {code: 4, codeName: ""},
      ],
      requirementType:1,
    },
    {
      title: "线下课程",
      name: "offlineState",
      dataIndex: "offlineState",
      tableItem: {width: 100},
      dict: [
        {code: 0, codeName: "● 合格"},
        {code: 1, codeName: "● 不合格"},
        {code: 3, codeName: "○ "},
        {code: 4, codeName: ""},
      ],
      requirementType:2,
    },
    {
      title: "人员测评",
      name: "personnelState",
      dataIndex: "personnelState",
      tableItem: {width: 100},
      dict: [
        {code: 0, codeName: "● 合格"},
        {code: 1, codeName: "● 不合格"},
        {code: 3, codeName: "○ "},
        {code: 4, codeName: ""},
      ],
      requirementType:3,
    },
    {
      title: "个人简历",
      name: "resumeState",
      dataIndex: "resumeState",
      tableItem: {width: 100},
      dict: [
        {code: 0, codeName: "● 合格"},
        {code: 1, codeName: "● 不合格"},
        {code: 3, codeName: "○ "},
        {code: 4, codeName: ""},
      ],
      requirementType:5,
    },
    {
      title: "性格测评",
      name: "mbtiState",
      dataIndex: "mbtiState",
      tableItem: {width: 100},
      dict: [
        {code: 0, codeName: "● 合格"},
        {code: 1, codeName: "● 不合格"},
        {code: 3, codeName: "○ "},
        {code: 4, codeName: ""},
      ],
      requirementType:6,
    },
    {
      title: "面试结果",
      name: "interviewState",
      dataIndex: "interviewState",
      tableItem: {width: 100},
      dict: [
        {code: 0, codeName: "● 合格"},
        {code: 1, codeName: "● 不合格"},
        {code: 3, codeName: "○ "},
        {code: 4, codeName: ""},
      ],
      requirementType:7,
    },
    {
      title: "电工证",
      name: "electricCertState",
      dataIndex: "electricCertState",
      tableItem: {width: 100},
      dict: [
        {code: 0, codeName: "● 合格"},
        {code: 1, codeName: "● 不合格"},
        {code: 3, codeName: "○ "},
        {code: 4, codeName: ""},
      ],
      requirementType:8,
    },
    {
      title: "岗位认证",
      name: "positionAuthState",
      dataIndex: "positionAuthState",
      tableItem: {
        width: 100
      },
      dict: [
        {code: 0, codeName: "● 合格"},
        {code: 1, codeName: "● 不合格"},
        {code: 3, codeName: "○ "},
        {code: 4, codeName: ""},
      ],
      requirementType:9,
    },
    {
      title: "在线考试",
      name: "onlineExamState",
      dataIndex: "onlineExamState",
      tableItem: {width: 100},
      dict: [
        {code: 0, codeName: "● 合格"},
        {code: 1, codeName: "● 不合格"},
        {code: 3, codeName: "○ "},
        {code: 4, codeName: ""},
      ],
      requirementType:10,
    },
    {
      title: "在线课程",
      name: "onlineCourseState",
      dataIndex: "onlineCourseState",
      tableItem: {width: 100},
      dict: [
        {code: 0, codeName: "● 合格"},
        {code: 1, codeName: "● 不合格"},
        {code: 3, codeName: "○ "},
        {code: 4, codeName: ""},
      ],
      requirementType:11,
    },
  ];
  let columnsAll = columnsBase;
  if(headList && headList.length){
    headList.forEach(element => {
      let requirementType = element.requirementType;
      columns.forEach(e=>{
        if(e.requirementType==requirementType){
          e.title = element.showTitle
          columnsAll.push(e);
        }
      })
      columnsAll[columnsAll.length-1].tableItem = {}
    });
  }

  let columnsEnd = [
    {
      title: "实际培训状态",
      name: "trainFactStatusStr",
      dataIndex: "trainFactStatusStr",
      tableItem: {width: 120}
    },
    {
      title: "DP状态",
      name: "trainDpStatusStr",
      dataIndex: "trainDpStatusStr",
      tableItem: {width: 100}
    },
    {
      title: "推送状态",
      name: "pushStatusStr",
      dataIndex: "pushStatusStr",
      tableItem: {width: 120}
    }
  ];

  return [...columnsAll,...columnsEnd];
}

const templateConfig = (trainState, type,_this,data,headList) => {
  let btns =[]
  let positionAuthStateShow = true;
  if(headList && headList.length){
    headList.forEach(e=>{
      if(e.requirementType==3){
        btns.push("updatePersonnelState");
      }else if(e.requirementType==7){
        btns.push("viewResume");
      }else if(e.requirementType==9){
        btns.push("updatePositionAuthState");
        btns.push("lookPositionAuthState");
        positionAuthStateShow = false;
      }
    })
  }

  let showRowOperateView = true;
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns({type},_this,headList),
        searchBarProps: {
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          collapse: false,
          buttonSort: ['dealerConfirm', 'export','import'],
          buttons: [
            {
              key: 'dealerConfirm',
              custom: true,
              params: {children: '经销商达标确认'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "dealerConfirm",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              },
              recordChangeParams: ({record, rows}) => {
                return {disabled: trainState===2 || trainState===4 || trainState===5 }
              }
            },
            {
              key: 'export',
              custom: true,
              params: {icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return {...filters}
                }
              }
            },

            {
              key: "import",
              custom: true,
              params: { children: "导入岗位认证", type: "info" ,tooltip:type!= 12 ? "单一销售展厅经销商才可导入岗位认证":null},
              customOnClick: {
                key: "modal",
                params: {
                  modalParams: {
                    title: "导入岗位认证",
                    diy: (e) => (
                      <PositionAuthStateImport
                        {...e} 
                        requirementPersonnelDetailId={data.id} 
                        orgId={data.orgId}
                        brandId={data.brandId}
                        benchmark={data.benchmark}
                        state={data.state}
                        key={new Date()}
                        // ref={r => {
                        //   ref_ = r && r.getWrappedInstance();
                        // }}
                      />
                    ),
                    footer: null,
                    // onOk: () => {
                    //   ref_._ok(data);
                    // },
                    width: 1000
                  }
                }
              },
              recordChangeParams: ({ record, rows }) => {
                return { disabled:trainState===2 || trainState===4 || trainState===5,hidden:positionAuthStateShow}
              }
            },


          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          // selectType: "checkbox",
          isScroll: true,
          loading: false,
         // maxNum: 0,
        bordered: false,
        maxNum:2
        },
        rowOperateProps: {
          width:220
        },
        rowOperateSort: btns,
        //['updatePersonnelState', 'updateBenchmarkState','viewResume','updatePositionAuthState','lookPositionAuthState'],
        rowOperateView: showRowOperateView?[
          {
            key: "updatePersonnelState",
            custom: true,
            params: {children: "测评"},
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  title: "测评",
                  diy: (e) => {
                    return (
                      <UpdatePersonnelState
                        key={'requirements' + e.record.personId}
                        {...e}
                      />
                    )
                  },
                  footer: null,
                }
              },
              formatParams: (rows, record, filter) => {
                return {...record};
              }
            },
            recordChangeParams: ({record, rows}) => {
              let hidden = 0;
              if (type != null && type != undefined && type === 12){
                hidden = 1;
              }
              return {
                disabled: record.personnelState === 4 || trainState===2 || trainState===4 || trainState===5,
               // hidden:hidden
              }
            }
          },
          {
            key: "updateBenchmarkState",
            custom: true,
            params: {children: "实践结果"},
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  title: "实践结果",
                  //  width: "500px",
                  diy: (e) => {
                    return (
                      <UpdateBenchmarkState
                        key={'requirements' + e.record.personId}
                        {...e}
                      />
                    )
                  },
                  footer: null,
                }
              },
              formatParams: (rows, record, filter) => {
                return {...record};
              }
            },
            recordChangeParams: ({record, rows}) => {
              let hidden = 0;
              if (type != null && type != undefined && type === 12){
                hidden = 1;
              }
              return {
                disabled: record.benchmarkState === 4 || trainState===2 || trainState===4 || trainState===5,
               // hidden:hidden
              }
            }
          },
          {
            key: "updatePositionAuthState",
            custom: true,
            params: {children: "岗位认证评分"},
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  title: "岗位认证评分",
                  diy: (e) => {
                    return (
                      <UpdatePositionAuthState
                        key={'requirements' + e.record.personId+new Date().getTime()}
                        {...e}
                      />
                    )
                  },
                  footer: null,
                }
              },
              formatParams: (rows, record, filter) => {
                return {...record};
              }
            },
            recordChangeParams: ({record, rows}) => {
              return {
                disabled: record.positionAuthState === 4 || trainState===2 || trainState===4 || trainState===5,
              }
            }
          },
         
          {
            key: 'viewResume',
            custom: true,
            params: { children: '查看简历' },
            customOnClick: {},
            recordChangeParams: ({ record, rows }) => {
              let { personId,resumeState } = record
              let disabled = 1;
              if (resumeState!=null && resumeState !== undefined && resumeState===0 ){
                disabled = 0;
              }
              let tk = Storage.getStorage('token');
              return {
                disabled:disabled,
                onClick: () => {
                  window.open(`${constants.env.sys_user_url}/#/interview/resume?tk=${tk}&lookPersonId=${personId}`)
                }
              }
            }
          },

          {
            key: "lookPositionAuthState",
            custom: true,
            params: {children: "查看岗位认证评分"},
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  title: "查看岗位认证评分",
                  diy: (e) => {
                    return (
                      <LookPositionAuthState
                        key={'requirements' + e.record.personId+new Date().getTime()}
                        {...e}
                      />
                    )
                  },
                  footer: null,
                }
              },
              formatParams: (rows, record, filter) => {
                return {...record};
              }
            },
            recordChangeParams: ({record, rows}) => {
              return {
                disabled: !(record.positionAuthState === 0 ||  record.positionAuthState === 1),
              }
            }
          },
        ]:undefined,
        commonOperate: {
          //add: true,
          //update: true
        }
      }
    }
  }
};

const apis = (record) => {
  const {orgId, brandId, benchmark, state, id,type} = record;
  return {
    list: {
      path: `${componentName}/getListByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: {pageNum: 1, size: 20, orgId, brandId, benchmark, state,dealerType:type}
      }
    },
    headList: {
      path: `${componentName}/getHeadList`,
      payload: {
        key: `${componentName}@headList`,
        apiParams: {id,orgId, brandId, benchmark, state,dealerType:type}
      }
    },
    export: {
      path: `${componentName}/getList`,
      payload: {
        key: `${componentName}@getList`,
        apiParams: {pageNum: 1, pageSize: 10, orgId, brandId, benchmark, state,dealerType:type}
      }
    },
    dealerConfirm: {
      path: `requirementPersonnel/dealerConfirm`,
      payload: {
        key: `requirementPersonnel@dealerConfirm`,
        apiParams: {pageNum: 1, pageSize: 10, id}
      }
    },
  }
}


let reduxTemplateCofig = (args) => {
  const {record} = args;
  return {
    apis: apis(record),
    componentName,
    initApiKeys: ['list','headList'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
